<div class="container">
    <form [formGroup]="galleryForm">

        <div id="choosePicture">
            <div class=" row title ">

                <div class="col-sm-12">
                    <b>{{'components.editRequest.choosePhoto' | translate}}</b>
                    <button type="button" class="btn btn-link btn-add" (click)="onAddNewMedia()" *ngIf="canAddNewMedia()"> <i class="fa fa-plus-circle"></i></button>

                </div>
                <div class="col-sm-6" *ngFor="let oneMedia of listOfMedia">
                    <app-photos-select [file]="oneMedia" [pictureForm]="galleryForm" (removeMedia)="onRemoveMedia(oneMedia)" [title]="'FORM.PHOTO.TITLE' | translate" [btn]="'FORM.PHOTO.BTN' | translate"></app-photos-select>
                </div>
            </div>
            <div class="row value" *ngIf="showCancelSaveButtons">
                <div class="col-sm-6">
                    <button class="btnRound" type="button" (click)="closeGallery()">
                    <i class="fa fa-times" aria-hidden="true"></i> {{'components.editRequest.cancel' | translate}}
                    </button>
                </div>
                <div class="col-sm-6">
                    <button class="btnFilled" type="button" (click)="saveMediaSubscribed()">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> {{'components.editRequest.save' | translate}}
                    </button>
                </div>
            </div>

        </div>

    </form>
</div>